import React from "react";

const Dashboard = React.lazy(() => import("./Dashboard"));

const cryptoCustodyModuleConfig = {
  id: "crypto-custody",
  name: "Crypto Custody",
  description: "Time-locked crypto vaults with validator network for social engineering protection",
  version: "1.0.0",
  enabled: true,
  category: "crypto",
  order: 20,
  icon: "🔐",
  color: "#6d28d9",

  routes: [
    {
      path: "/crypto-custody",
      component: Dashboard,
      permissionLevel: "view",
      useLayout: true,
    },
  ],

  navigation: [
    {
      label: "Crypto Custody",
      path: "/crypto-custody",
      icon: "🔐",
      permissionLevel: "view",
    },
  ],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },

  quickActions: [
    {
      label: "My Vault",
      path: "/crypto-custody",
      icon: "🔐",
      description: "View your crypto custody vault",
    },
  ],
};

export default cryptoCustodyModuleConfig;
